module.exports = __webpack_public_path__ + "img/trophy.91be4429.svg";